<template>
  <el-dialog :title="title" :visible.sync="visible" :lock-scroll="true" width="818px" :before-close="handleClose">
    <div class="">
      <div style="padding: 24px 0;">
        <el-form ref="form" :model="form" :inline="false" label-width="100px" label-position="right" :rules="rules"
          style="text-align:left;">
          <el-form-item prop="posterName" label="海报名称">
            <el-input v-model.tirm="form.posterName" style="width: 300px;" placeholder="海报名称" clearable size="small" />
          </el-form-item>

          <el-form-item prop="copywriting" label="文案">
            <el-input v-model.tirm="form.copywriting" autosize type="textarea" style="width: 300px;" placeholder="请输入文案"
              clearable size="small" />
          </el-form-item>
          <el-form-item prop="extendType" label="类别">
            <el-select v-model.tirm="form.extendType" clearable style="width: 120px;" size="small" placeholder="类别">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item prop="sort" label="排序">
            <el-input v-model="form.sort" style="width: 300px;" clearable size="small" type="number" />
          </el-form-item>

          <el-form-item prop="extendPlacard" label="图片">
            <imgUpload :limit="1" v-model="form.extendPlacard" :isEdit="disabled" style="position:relative;top:0px;"
              @onRemoveHandler="onRemoveHandler" @onSuccessUpload="onSuccessUpload">
              <template slot="tip">
                <p class="el-upload__tip">
                  备注:图片格式为jpg或png ,图片大小不得超过10M
                </p>
              </template>
            </imgUpload>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="submit()">保存</el-button>
            <el-button size="small" style="margin-left:12px" @click="handleClose()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>
    
<script>
import { salesExtendAdd, salesExtendUpdate } from "@/api/externalSalesRule";

import imgUpload from '@/components/imgUpload'
export default {
  props: {},
  data() {
    return {
      disabled: false,
      id: '',
      pageType: '',
      form: {
        posterName: '',
        copywriting: '',
        extendType: '',
        sort: '',
        extendPlacard: [],
      },
      options: [
        {
          value: 'SALESMAN',
          label: '业务员'
        },
        {
          value: 'CLIENT',
          label: '客户'
        },
      ],
      rules: {
        posterName: [{ required: true, message: '请填写通用名', trigger: 'blur' }],
        copywriting: [{ required: true, message: '请填写文案', trigger: 'blur' }],
        extendType: [{ required: true, message: '请选择类别', trigger: 'blur' }],
        sort: [{ required: true, message: '请填写排序', trigger: 'blur' }],
        extendPlacard: [{ required: true, message: '请上传图片', trigger: 'blur' }],
      },
      title: '',
      visible: false,
    }
  },
  components: { imgUpload },
  created() {
    this.id = this.$route.query.id || ''
    if (this.id) {
      this.query
    }
  },
  mounted() {

  },
  watch: {},
  methods: {
    onSuccessUpload(e) {
      this.form.extendPlacard = [e];
      console.log(this.form.extendPlacard)
    },
    onRemoveHandler(e) {
      this.form.extendPlacard = [];
    },
    submit() {
      console.log(this.form.extendPlacard)
      this.$refs['form'].validate((valid) => {
        if (valid) {
          let params = {
            posterName: this.form.posterName,
            extendType: this.form.extendType,
            copywriting: this.form.copywriting,
            sort: parseInt(this.form.sort),
            extendPlacard: this.form.extendPlacard[0],
          }
          if (this.pageType == 'edit') {
            params.id = this.form.id;
            salesExtendUpdate(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');
                this.handleClose();
              } else {
                this.$message.error(res.msg)
              }
            })
          } else {
            salesExtendAdd(params).then((res) => {
              if (res) {
                this.$message.success('提交成功');
                this.handleClose();
              } else {
                this.$message.error(res.msg)
              }
            })
          }

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handleClose() {
      this.visible = false;
      this.form = {
        posterName: '',
        copywriting: '',
        extendType: '',
        sort: '',
        extendPlacard: [],
      }
      this.$emit('getList')
    },
    init(row, type) {
      this.title = '推广海报';
      if (type == 'edit') {
        this.pageType = 'edit';
        this.isDisabled = false;
        this.title = '编辑推广海报';
        if (row) {
          this.form.id = row.id;
          this.form.posterName = row.posterName;
          this.form.extendType = row.extendType;
          this.form.copywriting = row.copywriting;
          this.form.sort = row.sort;
          this.form.extendPlacard = [row.extendPlacard];
        } else {
        }
      }
      if (type == 'add') {
        this.pageType = 'add';
        this.isDisabled = false;
        this.title = '新增推广海报'
      }
      this.visible = true;

      this.$forceUpdate();
    },
    query() {

    }
  }
}

</script>
<style lang="scss" scoped>
.eachRow {
  background-color: #fff;
  border-radius: 4px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}

.titleView {
  display: flex;
  align-items: center;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }

  .cpxhead {
    display: flex;
    align-items: center;
  }

  .mark {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
    width: 200px;
    line-height: 1.5;
    display: inline-block;
    font-weight: bold;
  }
}
</style>
  
  